/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { FileData } from '../file-uploader/file-uploader.interface';
import { FileUploaderService } from '../file-uploader/file-uploader.service';
import { FormFieldInterface } from './form-builder.interface';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import dayjs from 'dayjs';
import { LineItemPickerColumns, LineItemPickerOptions, LineItemPickerColumnType } from '../../components/line-item-picker/line-item-picker.interface';
import { LineItemPickerService } from 'app/components/line-item-picker/line-item-picker.service';
import { LineItemPickerComponent } from 'app/components/line-item-picker/line-item-picker.component';
import { HotToastService } from '@ngneat/hot-toast';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LineItemService } from 'app/core/services/lineitem/lineitem.service';
import _ from 'lodash';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() formElements: Array<FormFieldInterface> = [];
  @Input() checklistFormGroup: UntypedFormGroup;
  @Input() statusIndex: number;
  @Input() submitFormDisplayKey: string = 'update';
  @Input() cancelFormDisplayKey: string;
  @Input() showFooter: boolean = true;

  generateFilterForm: boolean = false;
  setBackgroundColor: any = {};
  currentContextIndex: any;
  currentField: any;
  @Input() set patchFormValues(data: any) {
    if (data && this.checklistFormGroup && this.formElements) {
      this.formElements.forEach((item: any) => {
        if (data[item.field_name]) {
          item.field_value = data[item.field_name];
        }
      });
      this.checklistFormGroup?.patchValue(data, { emitEvent: false });
      this.convertDataObjects();
    }
  }
  @Input() module?: any;
  @Input() previewForm: boolean = false;
  @Input() moduleUID: string;
  @Input() attachmentType: string;
  @Output() checklistValues: EventEmitter<any> = new EventEmitter();
  @Output() checklistChanges: EventEmitter<any> = new EventEmitter();
  uploaderAllowedTypes: any = {
    'MULTI_IMAGE' : ['image'],
    'VIDEO': ['video']
  }
  attachmentTypes: any = {
    'MULTI_IMAGE' : 'IMAGE',
    'VIDEO': 'VIDEO'
  }
  uploaderDiscription: any =  {
    'MULTI_IMAGE' : {
      descriptionKey: 'checklist.panel.attachment.description',
      descriptionName: 'Supported Files: Image'
    },
    'VIDEO': {
      descriptionKey: 'checklist.panel.attachment.image.description',
      descriptionName: 'Supported Files: Video'
    }
  }
  options: FileData = {
    multiple: true,
    attachmentType: 'JOB_NOTE',
    showProgress: false,
    showPreview: true,
    uploadDetails: false,
    setMaxLimit: true,
    allowFileTypes: ['image'],
    header: {
      isHeader: true,
      headerDisplayKey: 'checklist.panel.attachment.header',
      headerDisplayName: 'Add Checklist Attachments',
    },
    description: {
      descriptionKey: 'checklist.panel.attachment.description',
      descriptionName: 'Supported Files: Image'
    },
    close: {
      isClose: true,
      closeDisplayKey: 'close.text',
      closeDisplayName: 'Close',
    },
  };

  multipleAttachments: any[];
  attachmentSubscription: Subscription;
  currentSelectedFieldName: any;
  timePickerModel: any = {};
  Object = Object;
  //LineItem
  selectedLineItems: any[] = [];
  acceptedFileFormat: string = '';
  private _currentFormValue: any;
  private _formValueChange$: Subscription;
  tableValidationObject: any = {};
  enableMeridian: boolean = false;

  //Context Menu - Table
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @ViewChild('contextMenu') contextMenu!: MatMenu;
  contextMenuPosition = { x: '0px', y: '0px' };

  constructor(
    private fileUploadService: FileUploaderService,
    public _utilityService: UtilityService,
    private timeFormatPipe: TimeFormatPipe,
    private zuperDialogService: ZuperDialogService,
    private lineItemPickerService: LineItemPickerService,
    private localStorageService: LocalStorageService,
    private _lineItemService: LineItemService,
    private toast: HotToastService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService
  ) { /* TODO document why this constructor is empty */ }

  ngOnInit(): void {
    this.acceptedFileFormat = this._utilityService.acceptedFileFormat;
    this.enableMeridian = this._utilityService.showMeridian;
    this.addShowFieldBasedOnDependency();
    this.convertDataObjects();
    this.listenAndEmitFormChanges();
  }

  addShowFieldBasedOnDependency(): void{
    this.formElements.forEach((element: any) => {
      element['showFieldBasedOnDependency'] = this.showFieldBasedOnDependency(element);
    });
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('checklistFormGroup' in changes && changes['checklistFormGroup']['firstChange'] === false) {
      this.addShowFieldBasedOnDependency();
      this.convertDataObjects();
      this.checklistFormGroup?.patchValue(this._currentFormValue);
      this.listenAndEmitFormChanges();
    }
  }

  ngOnDestroy(): void {
    this._formValueChange$?.unsubscribe();
  }

  listenAndEmitFormChanges(): void{
    this._formValueChange$ = this.checklistFormGroup?.valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((res: any) => {
      this.addShowFieldBasedOnDependency();
      const data = this.prepareCheckListPayload();
      this._currentFormValue = res;
      this.isTableComponentValid();
      this.checklistChanges.emit(data);
    });
  }

  convertDataObjects(): void {
    this.formElements.forEach((element: any) => {
      switch (element?.field_type) {
        case 'TIME':
          this.timePickerModel = {
            ...this.timePickerModel,
            [element?.field_name]: element?.field_value ? moment(dayjs(element?.field_value, 'HH:mm:ss').format()) : moment(dayjs().format())
          };
          break;
        case 'DATETIME':
          this.timePickerModel = {
            ...this.timePickerModel,
            [element?.field_name]: element?.field_value ? moment(dayjs(element?.field_value).format()) : moment(dayjs().format())
          };
          break;
        case 'TABLE':
          const tableValue = this.checklistFormGroup?.value[element?.field_name] || [];
          this.timePickerModel = {
            ...this.timePickerModel,
            [element?.field_name]: tableValue
          };
          tableValue.forEach((row: any[], rowIndex: number) => {
            element?.field_meta?.columns?.forEach((column: any, columnIndex: number) => {
              const timeValue = row[columnIndex];
              const key = `${element?.field_name}_${rowIndex}_${columnIndex}`;
              if (column?.field_type === 'TIME') {
                if (!this._utilityService.isEmptyOrUndefined(timeValue)) {
                  this.timePickerModel = {
                    ...this.timePickerModel,
                    [key]: moment(dayjs(timeValue, 'HH:mm:ss').format())
                  };
                } else {
                  this.timePickerModel = {
                    ...this.timePickerModel,
                    [key]: null
                  };
                }
              } else if (column?.field_type === 'DATETIME') {
                if (!this._utilityService.isEmptyOrUndefined(timeValue)) {
                  this.timePickerModel = {
                    ...this.timePickerModel,
                    [key]: dayjs(timeValue).isUTC ? dayjs(timeValue)?.format('YYYY-MM-DD HH:mm:ss') : dayjs(timeValue)?.utc()?.format('YYYY-MM-DD HH:mm:ss')
                  };
                } else {
                  this.timePickerModel = {
                    ...this.timePickerModel,
                    [key]: null
                  };
                }
              } else if (column?.field_type === 'DATE') {
                if (!this._utilityService.isEmptyOrUndefined(timeValue)) {
                  this.timePickerModel = {
                    ...this.timePickerModel,
                    [key]: moment(dayjs(timeValue,'YYYY-MM-DD')?.format())
                  };
                } else {
                  this.timePickerModel = {
                    ...this.timePickerModel,
                    [key]: null
                  };
                }
              }
            });
          });
          break;
      }
    });
  }

  getAttachmentfileName(attachment: any): string {
    let type: string = 'file';
    if (attachment) {
      const splittedValue: string[] = attachment?.attachment ? attachment?.attachment.split('/') : attachment.split('/');
      type = splittedValue[splittedValue.length - 1];
    }
    return type;
  }

  showFieldBasedOnDependency(formField): boolean {
    let showField = true;
    if (formField?.hide_field) {
      showField = false;
    }
    if (formField?.hide_to_fe && this.localStorageService.getLocalStorage('user')?.role?.role_key === 'FIELD_EXECUTIVE') {
      showField = false;
    }
    if (formField?.is_dependent) {
      if (formField?.dependent_options?.length > 0) {
        let canShow: boolean = false;
        let formValue: any = this.checklistFormGroup?.controls?.[formField?.dependent_on]?.value;
        //we validating it separtely since field type select will not have value of type array
        if (Array.isArray(formValue) && formValue?.length > 0) {
          formValue = formValue.map((value: any) => value?.trim());
        }
        if (formValue) {
          if (Array.isArray(formValue) && formValue?.length > 0 && Array.isArray(formField?.dependent_options)) {
            canShow = formValue.some((value: any) => 
              typeof value === 'string' && formField?.dependent_options?.some((option: string) => 
                typeof option === 'string' && value.trim() === option.trim()
              )
            );
          } else {
            canShow = formField?.dependent_options?.some((option: string) => 
              typeof formValue === 'string' && typeof option === 'string' && formValue?.trim() === option?.trim()
            );
          }
        }
        
        showField = canShow;
      }
    }

    if (showField) {
      let validators = [];
      if (formField?.is_required) {
        validators = [...validators, Validators.required];
      }
      if (!this._utilityService.isEmptyOrUndefined(formField?.max_value)) {
        validators = [...validators, Validators.max(formField?.max_value)];
      }
      if (!this._utilityService.isEmptyOrUndefined(formField?.min_value)) {
        validators = [...validators, Validators.min(formField?.min_value)];
      }
      if (formField?.regex_value) {
        validators = [...validators, Validators.pattern(formField?.regex_value)];
      }
      this.checklistFormGroup?.controls[formField?.field_name]?.setValidators(validators);
       this.checklistFormGroup?.controls[formField?.field_name]?.updateValueAndValidity();
    }

    if (!showField) {
      const fieldInitialValue: any = formField?.field_type === 'TABLE' ? formField?.field_value ?? [] : null;
      this.checklistFormGroup?.controls[formField?.field_name]?.clearValidators();
      this.checklistFormGroup?.controls[formField?.field_name]?.setValue(fieldInitialValue, { emitEvent: false });
       this.checklistFormGroup?.controls[formField?.field_name]?.updateValueAndValidity();
    } else if (showField && this._utilityService.isEmptyOrUndefined(this.checklistFormGroup?.controls[formField?.field_name]?.value) && formField?.default_option === true && formField?.field_options[0]) {
      this.checklistFormGroup?.controls[formField?.field_name]?.setValue(formField?.field_options[0]);
       this.checklistFormGroup?.controls[formField?.field_name]?.updateValueAndValidity();
    }

    return showField;
  }

  openFileUploaderModel(event, fieldName, element, type): void {
    if ( this.checklistFormGroup?.controls[fieldName]?.value?.length > 0) {
      const attachments =  this.checklistFormGroup?.controls[fieldName]?.value?.map((data: any) => ({
        attachment_path: data?.attachment ? data?.attachment : data,
        attachment_uid: '',
        attachment_name: this.getAttachmentfileName(data),
        attachment_size: '',
      }));

      this.fileUploadService.previewFiles.next([...attachments]);
      this.fileUploadService.attachments.next(attachments);
    }
    this.currentSelectedFieldName = fieldName;
    event?.preventDefault();
    event.stopPropagation();
    if(this.moduleUID){
      this.options['module'] = this.module;
      this.options['moduleUid'] = this.moduleUID;
      this.options['attachmentType'] = this.attachmentType;
    }
    const options = {...this.options,
                    allowFileTypes:this.uploaderAllowedTypes[type],
                    acceptedFileFormat: this._utilityService.allowedFileFormats[type],
                    description: {
                      descriptionKey: this.uploaderDiscription[type]?.descriptionKey,
                      descriptionName: this.uploaderDiscription[type]?.descriptionName,
                    }};
    const attachmentDialog = this.zuperDialogService.openCustom(FileUploaderComponent, {
      extraClass: 'note-file-uploader',
      data: options
    });
    attachmentDialog.disableClose = true;
    attachmentDialog.afterClosed().subscribe((_result: any) => {
      const attachmentSubscription: Subscription = this.fileUploadService?.attachments.subscribe((attachments: any) => {
        const attachmentCollection: any[] = [];
        if (attachments) {
          attachments.forEach((attachment: any) => {
            attachmentCollection.push({
              attachment: attachment.attachment_path,
              attachment_uid: attachment.attachment_uid,
              attachment_name: attachment.attachment_name,
              attachment_size: attachment.attachment_size,
              attachment_type: this.attachmentTypes[type]
            });
          });
          this.multipleAttachments = attachmentCollection;
          const formElement: any = document.getElementById(element);
          formElement.innerHTML = `${this.multipleAttachments?.length} files selected`;
          this.checklistFormGroup?.patchValue({ [fieldName]: this.multipleAttachments });
        }
      });
      attachmentSubscription.unsubscribe();
      this.fileUploadService.previewFiles.next([]);
      this.fileUploadService.attachments.next([]);
    });
  }

  isTableComponentValid() :any{
    let isvalid = true;
    let tableComponents = this.formElements.filter((data: any)=>data?.field_type === 'TABLE');
    tableComponents.forEach((element: any) => {
      let currentTableValid = true;
      if (element?.field_meta?.columns?.length > 0) {
      element?.field_meta?.columns.forEach((column: any, index: number) => {
        if (column?.required === true) {
          this.checklistFormGroup.controls[element?.field_name]?.value.forEach((rowData: any)=>{
            if(this._utilityService.isEmptyOrUndefined(rowData[index])){
              isvalid = false;
              currentTableValid = false;
            }
          })
        }
      });
      }
      this.tableValidationObject = {...this.tableValidationObject,[element?.field_name]: currentTableValid};
    });
    return isvalid
  }

  toggleRowBackground(fieldName: string, index: number): void{
    if (!this.setBackgroundColor[fieldName]) {
      this.setBackgroundColor[fieldName] = {};
    }
    this.setBackgroundColor[fieldName][`${index}`] = !this.setBackgroundColor[fieldName]?.[`${index}`];
  }

  onFormSubmitted(): void {
    this.generateFilterForm = true;
    this.checklistFormGroup?.markAllAsTouched();
    if (this.checklistFormGroup?.valid && this.isTableComponentValid()) {
      const payload = {
        checklist: this.prepareCheckListPayload(),
        index: this.statusIndex
      };
      this.checklistValues.emit(payload);
      this.generateFilterForm = false;
    }
  }

  prepareCheckListPayload(): any {
    let payloadData = [];
    const finalElements = this.formElements.filter((data: any) => {
      let returnData: any;
      if (data?.is_dependent) {
        if (data?.dependent_options?.length > 0) {
          let formValue: any = this.checklistFormGroup?.controls?.[data?.dependent_on]?.value;
          //we validating it separtely since field type select will not have value of type array
          if (Array.isArray(formValue) && formValue?.length > 0) {
            formValue = formValue.map((value: any) => value?.trim());
          }
          if (formValue) {
            data?.dependent_options?.forEach((option: string) => {
              if (formValue?.includes(option?.trim())) {
                returnData = data;
              }
            });
          }
        }
      } else {
        returnData = data;
      }
      return returnData;
    });
    finalElements.forEach((element: any) => {
      let obj = {};
      const checklistValue = this.checklistFormGroup?.controls?.[element.field_name]?.value;
      switch (element?.field_type) {
        case 'TIME':
          obj = {
            answer: checklistValue ? dayjs(checklistValue, this._utilityService?.timeFormat).format('HH:mm:ss') : '',
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
            meta_data: {
              description: element?.field_description ?? null
            }
          };
          break;
        case 'DATETIME':
          obj = {
            answer: checklistValue ? dayjs(checklistValue)?.utc()?.format('YYYY-MM-DD HH:mm:ss') : '',
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
            meta_data: {
              description: element?.field_description ?? null
            }
          };
          break;
        case 'DATE':
          obj = {
            answer: checklistValue ? dayjs(checklistValue)?.format('YYYY-MM-DD') : '',
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
            meta_data: {
              description: element?.field_description ?? null
            }
          };
          break;
        case 'LOOKUP':
          if (checklistValue && checklistValue?.products?.length === 0) {
            this.checklistFormGroup?.controls[element.field_name]?.setValue(null);
            this.checklistFormGroup?.controls[element?.field_name]?.updateValueAndValidity();
            this.checklistFormGroup?.markAllAsTouched();
          }
          obj = {
            module: element?.module,
            meta_data: { ...checklistValue, description: element?.field_description ?? null },
            answer: '',
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
          };
          break;
        case 'MULTI_IMAGE':
        case 'VIDEO':
          obj = {
            answer: Array.isArray(checklistValue) ?
              checklistValue.map((data: any) => !this._utilityService.isEmptyOrUndefined(data.attachment) ? data?.attachment : data).join(',') :
              checklistValue,
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
            meta_data: {
              description: element?.field_description ?? null
            }
          };
          break;
          case 'TABLE':
          const rowData = this.getTablePostData(checklistValue,element?.field_meta?.columns)
          obj = {
            answer:'',
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
            meta_data: {
              columns: element?.field_meta?.columns ?? [],
              rows: rowData,
              description: element?.field_description ?? null
            }
          };
          break;
        default:
          obj = {
            answer: Array.isArray(checklistValue) ?
              checklistValue.join(',') :
              checklistValue,
            hide_to_fe: element?.hide_to_fe,
            question: element?.field_name,
            type: element?.field_type,
            meta_data: {
              description: element?.field_description ?? null
            }
          };
      };
      if (this.Object.keys(obj)?.length > 0) {
        payloadData = [...payloadData, obj];
      }
    });
    return payloadData;
  }

  getTablePostData(rowData :any,columns): any{
    const returnData = [];
    const tableData = rowData;
    if(columns && tableData?.length > 0){
      tableData?.forEach((rowvalue: any)=>{
        const rowObj = rowvalue?.map((data: any,index)=>({question:columns[index]?.field_name,answer:this.getTablePostDataValue(data,columns[index]?.field_type)}));
        returnData.push(rowObj);
      });
    }
    return returnData;
  }

  getTablePostDataValue(data: any,type: string): any{
    switch(type){
      case 'TIME':
        return this._utilityService.isEmptyOrUndefined(data) ? data : dayjs(data, 'HH:mm').format('HH:mm:ss');
      case 'DATETIME':                                                                                                                                      
        return this._utilityService.isEmptyOrUndefined(data) ? data : dayjs(data)?.format('YYYY-MM-DD HH:mm:ss');
      case 'DATE':
        return this._utilityService.isEmptyOrUndefined(data) ? data : dayjs(data)?.format('YYYY-MM-DD');
      default:
        return data;                                                                                                          
    }
  }

  onCheckboxValueChange(value, element): void {
    const multiItemValue = this.checklistFormGroup?.controls?.[element]?.value ?? [];
    let currentValue = [];
    if (multiItemValue?.length && multiItemValue?.includes(value)) {
      currentValue = multiItemValue?.filter((data: any) => data !== value);
    } else {
      currentValue = [...multiItemValue, value];
    }
    this.checklistFormGroup?.controls[element]?.setValue(currentValue);
    this.checklistFormGroup?.controls[element]?.updateValueAndValidity();
  }

  onFileUploadValueChange(event: any, formField: string, field_type: string): void {
    if (field_type?.toUpperCase() === 'IMAGE' && event?.target?.files[0]?.type?.split('/')[0]?.toUpperCase() !== 'IMAGE') {
      event.target.value = null;
      this.checklistFormGroup?.controls[formField]?.setValue(null);
      this.checklistFormGroup?.controls[formField]?.updateValueAndValidity();
      this.toast.error(this.translate.instant('checklist.panel.attachment.description'));
      return;
    }

    if (event?.target && event?.target?.files && event?.target?.files?.length) {
      const params = {
        'module': this.module,
        'moduleUid': this.moduleUID,
        'attachmentType': this.attachmentType
      };
      this._utilityService.uploadFile(event?.target?.files[0], params).subscribe((response: any) => {
        this.checklistFormGroup?.controls[formField]?.setValue(response?.data?.attachment_path);
        this.checklistFormGroup?.controls[formField]?.updateValueAndValidity();
      });
    }
  }

  setTimeFormControl(formField): void {
    if (this.timePickerModel[formField].format('HH:mm') !== moment(dayjs().format()).format('HH:mm')) {
      this.checklistFormGroup?.controls[formField]?.setValue(this.timeFormatPipe.transform(this.timePickerModel[formField]));
      this.checklistFormGroup?.controls[formField]?.updateValueAndValidity();
    }
  }

  setTimeTableModel(event,fieldName,i,j): void {
    const tableData =  this.checklistFormGroup?.controls[fieldName]?.value;
    if (!this._utilityService.isEmptyOrUndefined(event) && event.format('HH:mm') !== moment(dayjs().format()).format('HH:mm')) {
      tableData[i][j] = this.timeFormatPipe.transform(event);
      this.checklistFormGroup?.controls[fieldName]?.setValue(tableData);
      this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
    }
  }

  getModelValue(fieldName): any {
    return moment(dayjs( this.checklistFormGroup?.controls[fieldName]?.value, 'HH:mm:ss').format());
  }

  setDate(picker, formField): void {
    const date = this.checklistFormGroup?.controls[formField];
    const newDate = date?.status.toLowerCase() === 'valid' && !this._utilityService.isEmptyOrUndefined(date?.value) ? date?.value : moment(new Date());
    const parsedDate = moment(newDate).set('second', 0);
    picker.select(parsedDate);
  }

  setTableDateTimePicker(picker, formField,rowIndex,columnIndex): void {
    const date = _.cloneDeep(this.checklistFormGroup?.value[formField][rowIndex][columnIndex]);
    const newDate = !this._utilityService.isEmptyOrUndefined(date) ? date : moment(new Date());
    const parsedDate = moment(newDate).set('second', 0);
    picker.select(parsedDate);
  }
  openLineItemPicker(fieldName: any): void {
    this.selectedLineItems = this.checklistFormGroup?.controls[fieldName]?.value?.products ?? [];
    this.lineItemPickerService.selectedLineItems.next(this.selectedLineItems);
    let remoteData = null;
    remoteData = {
      dataUrl: this._lineItemService.lineItemAPIUrls.productUrl,
      params: {
        'filter.product_type': 'PRODUCT,PARTS,SERVICE,BUNDLE',
      }
    };

    let options: any = {
      enableOutOfStockProduct: true,
      multipleLineItems: true,
      pickerType: 'modal',
      columns: this.getLineItemsProductColumns(),
      addFromProductGroup: false,
      showMaxQuantityError: true,
      remoteData: remoteData,
      filters: {
        search: {
          enabled: true
        },
        category: {
          enabled: true
        }
      },
      header: {
        isEnabled: true,
        headerDisplayKey: 'lineitem.picker.header.choose_text',
        headerDisplayName: 'Choose Line Item'
      },
      footer: {
        isEnabled: true,
        buttonDisplayKey: 'lineitem.picker.add.product_text',
        buttonDisplayName: 'Add Product'
      }
    };
    const lookupData = this.formElements?.find((element: any) => element?.field_name === fieldName)?.look_up_data;
    const lookupType = this.formElements?.find((element: any) => element?.field_name === fieldName)?.original_template?.lookup_module;
    if (lookupData?.length || lookupType === 'JOB_PRODUCT') {
      options = { ...options, data: lookupData };
    }
    if(lookupType === 'JOB_PRODUCT') {
      delete options.remoteData;
    }
    if(this.module){
      options['module'] = this.module;
    }
    const lineItemDialog: any = this.zuperDialogService.openCustom(LineItemPickerComponent,
      {
        extraClass: 'line-item-picker-container',
        data: {
          options: options as LineItemPickerOptions
        }
      });
    lineItemDialog.disableClose = true;
    const onAddItemClicked: any = this.lineItemPickerService.onAddItemClicked.subscribe((response: any) => {
      lineItemDialog.close(response);
    });
    lineItemDialog.afterClosed().subscribe((lineItems: any) => {
      onAddItemClicked.unsubscribe();
      if (Array.isArray(lineItems) && lineItems?.length > 0) {
        this.selectedLineItems = lineItems;
        const products = {
          products: this.selectedLineItems
        };
        this.checklistFormGroup?.controls[fieldName]?.setValue(products);
        this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
      } else if (this.selectedLineItems?.length) {
        const products = {
          products: this.selectedLineItems
        };
        this.checklistFormGroup?.controls[fieldName]?.setValue(products);
        this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
      } else {
        this.checklistFormGroup?.controls[fieldName]?.setValue(null);
        this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
      }

      this.lineItemPickerService.selectedLineItems.next([]);
    });
  }

  getLineItemsProductColumns(): LineItemPickerColumns[] {
    return [{
      type: LineItemPickerColumnType.LINE_ITEM,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.CATEGORY,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.TYPE,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.BRAND,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.SPECIFICATION,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.PRICE,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.QUANTITY,
      isEditable: true,
      isRequired: true
    }];
  }

  isFormDisabled(): any {
    let isDisabled = false;
    this.formElements.forEach((element: any) => {
      if ((element?.meta_options?.restrict_status_update?.is_enabled === true) ||
        (element?.original_template?.meta_options?.restrict_status_update?.is_enabled === true)) {
        if (this.checklistFormGroup?.value[element?.field_name] && Array.isArray(this.checklistFormGroup?.value[element?.field_name])) {
          this.checklistFormGroup?.value[element?.field_name].forEach((value: any) => {
            if (element?.meta_options?.restrict_status_update?.restricted_options?.includes(value)) {
              isDisabled = true;
              return isDisabled;
            }
          });
        } else {
          if (element?.meta_options?.restrict_status_update?.restricted_options?.includes(this.checklistFormGroup?.value[element?.field_name])) {
            isDisabled = true;
            return isDisabled;
          }
        }
      }
    });
    return isDisabled;
  }

  isFieldDisabled(element): boolean {
    let isDisabled = false;
    if ((element?.meta_options?.restrict_status_update?.is_enabled === true) ||
      (element?.original_template?.meta_options?.restrict_status_update?.is_enabled === true)) {
      if (this.checklistFormGroup?.value[element?.field_name] && Array.isArray(this.checklistFormGroup?.value[element?.field_name])) {
        this.checklistFormGroup?.value[element?.field_name].forEach((value: any) => {
          if (element?.meta_options?.restrict_status_update?.restricted_options?.includes(value)) {
            isDisabled = true;
            return isDisabled;
          }
        });
      } else {
        if (element?.meta_options?.restrict_status_update?.restricted_options?.includes(this.checklistFormGroup?.value[element?.field_name])) {
          isDisabled = true;
          return isDisabled;
        }
      }
    }
    return isDisabled;
  }

  /**
   * Updates a specific cell in a table form control with a new value.
   * 
   * @param event - The new value to set in the table cell.
   * @param fieldName - The name of the form control representing the table.
   * @param rowIndex - The index of the row in the table to update.
   * @param columnIndex - The index of the column in the row to update.
   * @param type - The type of the field to update.
   */
  setTableModel(event: any, fieldName: string, rowIndex: number, columnIndex: number, type: string): void {
    // Ensure the fieldName exists in the form and tableData is not null
    const tableData =  this.checklistFormGroup?.controls[fieldName]?.value;
    if (tableData && Array.isArray(tableData) && tableData[rowIndex]) {
      let adjustedValue: any;
      // Adjust the value based on the type
      switch (type) {
        case 'DATE':
          adjustedValue = dayjs(event).format(this._utilityService.dateFormat);
          this.timePickerModel[fieldName+'_'+rowIndex+'_'+columnIndex] = event;
          break;
        case 'DATETIME':
          adjustedValue = dayjs(event).format(this._utilityService.dateTimeFormat);
          this.timePickerModel[fieldName+'_'+rowIndex+'_'+columnIndex] = event;
          break;
        // Add more cases as needed for other types
        default:
          adjustedValue = event?.target?.value;
      }

      // Update the specific cell in the table data with the adjusted value
      tableData[rowIndex][columnIndex] = adjustedValue;
      // Update the form control with the modified table data
      this.checklistFormGroup?.controls[fieldName]?.setValue(tableData);
      this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
    }
  }

  addTableRow(fieldName: string): void {
    const tableData =  this.checklistFormGroup?.controls[fieldName]?.value;
    const columns = this.formElements?.find((element: any) => element?.field_name === fieldName)?.field_meta?.columns;
    const newRow = columns?.map(() => null);
    tableData.push(newRow);
    this.checklistFormGroup?.controls[fieldName]?.setValue(tableData);
    this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
  }

  onContextMenu(event: MouseEvent, item: any, index?: any): any {
    event.preventDefault();
    this.currentField = item;
    this.currentContextIndex = index;
    this.contextMenuPosition.x = '10px';
    this.contextMenuPosition.y = (event.clientY + 15) + 'px';
    this.contextMenu['menuData'] = { 'item': item };
    this.changeDetectorRef.detectChanges();
    this.toggleRowBackground(item, index);
    this.menuTrigger.openMenu();
    this.contextMenu.focusFirstItem("mouse");
  }

  onContextMenuAction(fieldName: string, index: number): void {
    if(!this._utilityService.isEmptyOrUndefined(index)){
      let tableData =  this.checklistFormGroup?.controls[fieldName]?.value;
      tableData = tableData?.length > 1 ? tableData?.filter((data: any, ind: number)=> ind !== index) : [];
      this.toggleRowBackground(fieldName, index);
      Object.keys(this.timePickerModel)?.forEach((record: any)=>{
        if(record.includes(fieldName+'_'+index)){
          delete this.timePickerModel[record];
        }
      })
      this.checklistFormGroup?.controls[fieldName]?.setValue(tableData);
      this.checklistFormGroup?.controls[fieldName]?.updateValueAndValidity();
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  resetFile(fieldName: string, fileInput: HTMLInputElement): void {
    const control = this.checklistFormGroup?.controls[fieldName];
    if (fileInput) {
      fileInput.value = '';
    }
    if(control?.value){
      control.setValue(null);
      control.updateValueAndValidity();
    }
  }
}
